import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import BlogContent from '../components/BlogContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader';
import ExploreMore from '../components/ExploreMore'; 
import GetInTouch from '../components/GetInTouch';  
import withRouter from '../components/withRouter';
import { Helmet } from "react-helmet";
import {  base_url} from '../common/Constants';

class Blog extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
       
        return (
            <div>
                <Header/> 
                <Helmet>
                    <title>{metas[4].title}</title>  
                    <meta name="description" content={metas[4].meta_description} />
                    <meta name="keywords" content={metas[4].meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'blog'} />
                </Helmet>
                <PageHeader title="News & Updates" main_title="Media" banner={base_url+'assets/_nuxt/img/news.e3cfe93.jpg'} />
                <BlogContent content={JSON.parse(localStorage.getItem("content"))} blogs={JSON.parse(localStorage.getItem("blogs"))}  />  
                 <ExploreMore content={JSON.parse(localStorage.getItem("content"))}/>  
                <GetInTouch content={JSON.parse(localStorage.getItem("content"))}/>
                <Footer/>
      
        
        </div>
       
        )
    }

}
export default withRouter(Blog);;